<template>
  <main class="content-wrapper mt0 checkbox-dark pb0"  v-if="loaded">
    <div class="age-verification-section">
      <div class="age-verfication-content has-text-centered has-text-black">
        <div class="container">
          <img width="200px" v-if="vg_businessProfile.branding && vg_businessProfile.branding.logo_url" :src="vg_businessProfile.branding.logo_url" :alt="vg_businessProfile.name"/>
          <img v-else src="@/assets/img/logo.png"  alt="logo" width="200px"/>
          <h2 class="sf-pro-text-semibold mt30 mb5 is-size-5 has-text-centered has-text-black">Age Verification</h2>
          <p class="mb30 has-text-centered has-text-black is-size-7">You must be legal age to enter this site.</p>
          <div class="verfication-form">
            <div class="field">
              <div class="control">
                <div class="select is-full-width">
                  <validation-provider name="Province" ref="province" rules="required">
                    <template #default="{ errors }">
                      <select v-model="form.province">
                        <option value="" disabled>--Province--</option>
                        <option  v-for="(item, index) in province" selected v-bind:key="index + '_province'" :value="item.value">{{ item.name }}</option>
                      </select>
                      <span v-if="errors[0]" class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
            </div>

            <p class="has-text-grey is-size-6 has-text-centered mb30 has-text-black" v-if="form.province">
             You have to be over {{ getProvinceAge(form.province) }} years old to view the content on this website.
            </p>

           <div class="has-text-centered is-size-13 mt20 mb30 has-text-black">
              By clicking continue, you agree to the Budler <router-link :to="{ name: 'TermsConditions', query: $route.query}" target="_blank" class="has-underline hover-text-secondary">Terms of use </router-link> 
              and <router-link :to="{ name: 'PrivacyPolicy', query: $route.query}" target="_blank" class="has-underline hover-text-secondary">Privacy Policy</router-link>
          </div>

            <button @click="verifyVisitorAge()" class="button is-large bg-secondary text-white hover-opacity-7 is-full-width mb10" type="submit">CONTINUE</button>
            <button @click="iamUnderAge()" class="button is-large is-secondary-outline is-full-width" type="submit">I AM UNDERAGE</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>


<script>
import Env from '@/env';
import { mapGetters, mapActions } from 'vuex';
import Helpers from '@/Components/Helpers/Helpers';
import moment from 'moment';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import LocationApis from '@/Components/Controllers/LocationApis';

export default {
  name: 'VisitorAgeVerification',
  data() {
    return {
      screen: 1,
      loaded: false,
      form: {
        dob: '',
        province: '',
        remember: false,
      },
      dob:{
        day:'',
        month:'',
        year:'',
      },
      dobError: '',
    };
  },
  
  computed:{
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail", 
    }),
    availableYears() {
      let available = [];
      let currentYear = moment().format("YYYY");
      // Give 100 years down possibility
      for (let i = 1;; i++) {
        available.push(currentYear-i);
        if (i > 99)
           break;
      }
      return available;
    },
    province() {
      return Env.provinces;
    },
  },

  async mounted() {
    const visitor = this.$store.getters.getVisitorDetails;
    if (visitor.ageVerify === true) {
      // if age is already verified push to homepage
      return this.$router.push({ 
        name: 'HomePage', 
        params: { business_slug: this.$route.params.business_slug ? this.$route.params.business_slug : Env.defaultBusinessSlug },
        query: this.$route.query,
      });
    } else {
      // fetch the branding for this business
      this.loaded = false;
      this.va_spinner(true);
      let res = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug); 
      this.loaded = true;
      this.va_spinner(false);
      if(res.status == 200){
        //LocationApis.fetchNearest(_.isEmpty(this.userAddress) ? '' : this.userAddress.geometry)
      } else {
        this.va_snackbar({
          type: 'warning', 
          message: 'Cannot find the business. Redirecting....'
        });
        // If has landed router send to that url
        this.$router.push('/');
      }
    }
  },

  methods: {
    /**
     * Under age
     */
    async iamUnderAge() {
      let valid = await Helpers.validateRefs(this, ['province']);
      if(valid){
        this.va_snackbar({
          type: 'warning', 
          message: 'Sorry, You need to be over the age of ' + this.getProvinceAge(this.form.province) + ' to access this website.'
        });
      }
    },

    /**
     * Verify age
     */
    async verifyVisitorAge() {
      let valid = await Helpers.validateRefs(this, ['province']);
      if(valid){
      
        this.va_snackbar({
          type: 'success', 
          message: 'Thank you for verification.'
        });

        this.$store.dispatch('SET_VISITOR_DETAILS', {
          ageVerify: true,
          dob: '',
          province: this.form.province,
          remember: true,
        });      

        // If guest landed on another page and verify age return back to that page
        if(this.$store.getters.getLandingRoute){
          window.location.href = this.$store.getters.getLandingRoute;
        } else {
          this.$router.push({ 
            name: 'HomePage',
            query: this.$route.query,
          });
        }
      }
    },
    
    /**
     * Get province age limit
     */
    getProvinceAge(code) {
      if(!code){
        return '';
      }
      let provinceObj = _.find(this.province, { value: code });
      if(provinceObj){
        return provinceObj.age;
      }
      return '';
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    }),
  },
};



</script>

<style scoped>
.day-month-year-picker p{
    font-size: 12px;
    padding: 8px 20px;
    padding-bottom: 0;
}
.age-verification-section .verfication-form  .day-month-year-picker select{
    height: 32px;
    padding-top: 0;
}
.control.select.is-full-width.pr-5 {
    padding-right: 25px;
}
</style>